import { Spin, Tabs } from "antd";
import React, { useEffect } from "react";
import { TimetableStyled } from "./index.styled";
import Timetable from "./timetable";
import Icon from '@ant-design/icons';
import { ReactComponent as bus } from "assets/bus.svg";
import { ReactComponent as marker } from "assets/marker.svg";
import { useDispatch, useSelector } from "react-redux";
import { useAction } from "store/store";
import { createTimetableTripRouteAction } from "store/timetable/store";
import { TimetableState } from "store/timetable/reducer";

type State = {
    timetable?: TimetableState,
}

const Home: React.FC = () => {
    const dispatch = useDispatch<any>();
    const action = useAction(createTimetableTripRouteAction());
    const timetableState = useSelector((state: State) => state.timetable);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString)
        dispatch(action.getTimetableUser(urlParams.get('token') as string));
    }, [dispatch, action])

    return <TimetableStyled>
        <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab={<div><Icon rev='bus' component={bus} /> Horários</div>} key="1">
                <Timetable />
            </Tabs.TabPane>
            <Tabs.TabPane tab={<div><Icon rev='marker' component={marker} /> Mapa</div>} key="2">
                <Spin spinning={timetableState?.user == null}>
                    {timetableState?.user && <iframe style={{ width: '100%', height: 'calc(100vh - 128px)', minHeight: 300 }}
                    src={`https://gool.cittati.com.br/MapaPrevisao/GoolSystem/GMaps/MapaPrevisao/MapaPrevisao.aspx?chave=${timetableState.user}`}
                    title="Mapa GoolSystem" />}
                </Spin>
            </Tabs.TabPane>
        </Tabs>
    </TimetableStyled>
}

export default Home;
